import { type StateCreator, create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { BootstrapApplicationResult } from '@/utils/app.utils';

export type AssetDetailsModeValue = 'view' | 'edit';
export type AssetDetailsView = 'organize' | 'fulfill';

interface AssetDetailsState {
    mode: AssetDetailsModeValue;
    view: AssetDetailsView;
}

interface AppState {
    appInitLogged: boolean;
    assetDetails: AssetDetailsState;
    bootstrapResult: BootstrapApplicationResult | undefined;
}

interface AppActions {
    enterAssetDetailsEditMode: () => void;
    exitAssetDetailsEditMode: () => void;
    markAppInitLogged: () => void;
    resetAssetDetailsView: () => void;
    setAssetDetailsView: (view: AssetDetailsView) => void;
    setBootstrapResult: (bootstrapResult: BootstrapApplicationResult | undefined) => void;
}

interface State extends AppState, AppActions {}

const storeName = 'app';

const createAppStore: StateCreator<State, [['zustand/devtools', never]], [], State> = (set) => ({
    appInitLogged: false,
    assetDetails: {
        mode: 'view',
        view: 'organize',
    },
    bootstrapResult: undefined,

    enterAssetDetailsEditMode: () => {
        set((state) => ({
            assetDetails: {
                ...state.assetDetails,
                mode: 'edit',
            },
        }));
    },
    exitAssetDetailsEditMode: () => {
        set((state) => ({
            assetDetails: {
                ...state.assetDetails,
                mode: 'view',
            },
        }));
    },
    markAppInitLogged: () => {
        set({ appInitLogged: true });
    },
    resetAssetDetailsView: () => {
        set((state) => ({
            assetDetails: {
                ...state.assetDetails,
                view: 'organize',
            },
        }));
    },
    setAssetDetailsView: (view) => {
        set((state) => ({
            assetDetails: {
                ...state.assetDetails,
                view,
            },
        }));
    },
    setBootstrapResult: (bootstrapResult) => {
        set({ bootstrapResult });
    },
});

export const useAppStore = create<State>()(
    devtools(createAppStore, {
        name: storeName,
    })
);
